import { render, staticRenderFns } from "./SampleTestsTable.vue?vue&type=template&id=3a7a4ea2"
import script from "./SampleTestsTable.vue?vue&type=script&lang=js"
export * from "./SampleTestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports